import { render } from "./VkAuthButton.vue?vue&type=template&id=e5724084&scoped=true"
import script from "./VkAuthButton.vue?vue&type=script&lang=js"
export * from "./VkAuthButton.vue?vue&type=script&lang=js"

import "./VkAuthButton.vue?vue&type=style&index=0&id=e5724084&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5724084"]])

export default __exports__